import { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import { getServicioInt, ActualizaServicio } from "../../services/servicios";
import { ErrorContext } from "../../utils/context/error";
import Modal from "../modal";
import Icon from "../../Icons/services/Icon";
import IconG  from "../../Icons/general/Icon";
import IconModal from "./iconsmodal";
import { useValidacionFormulario } from "../../hooks/validacion";
import Switch from "../switch";


function ServiceModal({ show, AreaI, AreaFId, ServicioI, Tag, handleshow, onGuardado }) 
{
  const [habilita, setHabilita] = useState(false);
  const [area, setArea] = useState([]);
  const  [icon, setIcon] = useState("");
  const [showIconos, setShowIconos] = useState(false);
  const [Titulo, setTitulo] = useState("");
  const { setShowToast, setOpciones } = ErrorContext();
  const [datas, setDatas] = useState({AreaId:AreaI, 
                                      ServicioId:ServicioI, 
                                      Prefijo:null, 
                                      Icon:null, 
                                      NombreServ:'',
                                      Maximo:'',
                                      Prioritaria:'NO',
                                      Acompanante:'NO',
                                      CantPrio:null,
                                      CantNPrio:null,
                                      Tag:Tag,
                                      MaxDia:0
                                      })
  
  const {validarCampos, limpiarError, claseLabel, claseCampo,} = useValidacionFormulario(datas);
  const camposMayusculas = ["NombreServ","Prefijo"];

//----------------------------------------------------------------------------------------------------------------------
  const handleCancel = async () => 
    {
      handleshow(false);
    };

//----------------------------------------------------------------------------------------------------------------------
  const handleAceptar = async () => 
    {
      const esValido = validarCampos(["NombreServ","Prefijo","Maximo","AreaId"]);
      if (!esValido) return;
  
      setHabilita(true);
      setShowToast(false);
      const response = await ActualizaServicio(datas);
      if (response) 
        {
          if (response.status === 200) 
            {
              onGuardado(response.data.data); 
              handleshow(false);
            } 
          else 
            {
              const Mensaje = response.message;
              const opc = { type: "Danger", message: Mensaje, active: true };
              setOpciones(opc);
              setShowToast(true);
            }
        }
      setHabilita(false);
    };

//-------- Servicio por area e Id --------------------------------------------------------------------------------------
  const fillServicioInt = async (AreaId, ServicioId) => 
    {
      setShowToast(false);
      const response = await getServicioInt(AreaId, ServicioId);
      if (response) 
        {
          if (response.status === 200) 
            {
              setArea(response.data.area);
              setDatas({
                  ...datas,
                  AreaId: response.data.data.AreaId, 
                  ServicioId:response.data.data.ServicioId,  
                  NombreServ:response.data.data.NombreServ,
                  Prefijo:response.data.data.Prefijo ?? null,
                  Orden:response.data.data.Orden ?? null,
                  Maximo:response.data.data.Maximo ?? null,
                  Prioritaria:response.data.data.Prioritaria ?? "NO",
                  Acompanante:response.data.data.Acompanante ?? "NO",
                  CantPrio:response.data.data.CantPrio,
                  CantNPrio:response.data.data.CantNPrio,
                  Icon:response.data.data.Icon ?? null,
                  MaxDia:response.data.data.MaxDia ?? null,
              })
               
            } 
            else 
              {
                const Mensaje = response.message;
                const opc = { type: "Danger", message: Mensaje, active: true };
                setOpciones(opc);
                setShowToast(true);
            }
        }
    };

//----------------------------------------------------------------------------------------------------------------------
const handleChange = (e) => 
  {
    const { name, value, type, checked } = e.target;
    setDatas((prev) => ({

    ...prev,
    [name]:
      type === "checkbox"
        ? checked ? "SI" : "NO"
        : camposMayusculas.includes(name)
          ? value.toUpperCase()
          : value,
  }));
    limpiarError(name);
    setHabilita(false);
  };

//----------------------------------------------------------------------------------------------------------------------
const handleSetIcon = (nuevoIcono) => {
  setIcon(nuevoIcono);

  setDatas((prev) => ({
    ...prev,
    Icon: nuevoIcono,
  }));
};

//----------------------------------------------------------------------------------------------------------------------
  useEffect(() => 
   {
    if (show) 
      {
        fillServicioInt(AreaI, ServicioI);
        if (Tag !== 0) 
          {
            if (Tag === 1) setTitulo("Editar Servicio (" + ServicioI + ")");
            if (Tag === 2) setTitulo("Eliminar Servicio (" + ServicioI + ")");
          }
        else 
          {
            setTitulo("Nuevo Servicio");
         }
      }
  }, [show]);

//----------------------------------------------------------------------------------------------------------------------
  return (
    <>
      <Modal isOpen={show} onClose={()=>handleshow(false)} title={Titulo}>
         <div className="flex w-[26rem] lg:w-[30rem]">
            <form noValidate className="flex flex-col w-full">
                <div className="flex flex-col w-full h-full ">
                  <div className="w-full">
                    <label className={claseLabel("AreaId")}>Area</label>
                    <select id="area" name="AreaId" className={claseCampo("AreaId")} value={datas.AreaId} onChange={handleChange} label="Area" disabled={Tag === 2 || Tag === 1}>
                        <option value={0} disabled>
                           Seleccionar una Area...
                        </option>
                        {area.map((item) => 
                          {
                            return(
                              <option key={item.AreaId} value={item.AreaId}>
                                 {item.NombreArea}
                              </option>
                            );
                          }
                        )
                        }
                    </select>
                  </div>
                  <div className="w-full mt-4">
                      <label className={claseLabel("NombreServ")}>Nombre Servicio</label>
                          <input type="text" className={claseCampo("NombreServ")} name='NombreServ' value={datas.NombreServ} placeholder="Ingresa el nombre para el servicio" 
                            onChange={handleChange}
                            autoComplete="off" 
                            disabled={Tag === 2}>
                          </input>
                  </div>
                  {/* Selector del icono */}
                  <div className="w-full mt-4">
                    <label>Icono del servicio</label>

                    <div className="flex w-full gap-x-2">
                      <div className="flex h-[2.35rem] min-w-0 flex-1 items-center gap-x-2 rounded border border-gray-400 bg-white px-3">
                        <div className="flex h-6 w-full shrink-0 items-center justify-center text-gray-700">
                          {datas.Icon ? 
                            (
                              <Icon
                                svg={datas.Icon}
                                className="h-6 w-6 shrink-0 fill-current text-sidebar"
                              />
                            ) : 
                            (
                              <Icon
                                svg="noimage"
                                className="h-6 w-6 shrink-0 fill-current text-sidebar"
                              />
                            )}

                           <span className="w-full m-1 truncate text-sm text-gray-700">
                              {datas.Icon ? "Icono seleccionado" : "Ningún icono seleccionado"}  
                           </span>
                        </div>
                      </div>

                      <button type="button" onClick={() => setShowIconos(true)} disabled={Tag === 2}
                        className="group nobutton flex h-[2.35rem] shrink-0 items-center gap-x-2
                          rounded border border-sidebar px-3
                          text-sm font-medium text-sidebar
                          hover:bg-default
                          disabled:cursor-not-allowed
                          disabled:border-slate-300
                          disabled:text-slate-400
                        "
                      >
                        <IconG svg="square" className="w-[1.2rem] h-[1.2rem] fill-default group-hover:text-white" title="square" />
                        <span className="hidden sm:inline group-hover:text-white">Seleccionar icono</span>
                        <span className="sm:hidden group-hover:text-white">Seleccionar</span>
                      </button>
                    </div>
                  </div>

                  {/* Prefijo y dígitos */}
                  <div className="flex flex-row mt-4 gap-x-3">
                    <div className="w-[8rem]">
                      <label className={claseLabel("Prefijo")}>Prefijo</label>
                      <input type="text" name="Prefijo" value={datas.Prefijo} className={claseCampo("Prefijo")} onChange={handleChange} disabled={Tag === 2} maxLength={5} placeholder="Ej: LAB" />
                    </div>
                    <div className="w-[9rem]">
                      <label className={`${claseLabel("Maximo")} whitespace-nowrap`}>Dígitos Prefijo</label>
                      <input type="number" name="Maximo" value={datas.Maximo} className={claseCampo("Maximo")} placeholder="0" min="0" onChange={handleChange} disabled={Tag === 2}/>
                    </div>
                    <div className="w-[9rem]">
                      <label className={`whitespace-nowrap`}>Turnos x Días</label>
                      <input type="number"  name="MaxDia" value={datas.MaxDia} placeholder="0" min="0" onChange={handleChange} disabled={Tag === 2}/>
                    </div>
                    
                  </div>                     
                 <div className="flex flex-row mt-4 gap-x-2">
                    <div className=" flex w-[55%] flex-row items-center pt-3  gap-2">
                       <Switch name="Prioritaria"  className="mr-1" value={datas.Prioritaria} onChange={handleChange} checkedValue="SI" uncheckedValue="NO"/>
                        <label className="whitespace-nowrap"> Manejar Colas Prioritarias?</label>   
                    </div>
                    <div className="flex w-[45%] flex-row gap-x-2">
                       <div className="w-full">
                         <label>Prioritarias</label>
                         <input type="number" name="CantPrio" value={datas.CantPrio} placeholder="0" onChange={handleChange} label="Area" disabled={Tag === 2 || datas.Prioritaria !== "SI"}/>
                       </div>
                       <div className="w-full">
                        <label className="block lg:hidden">No Priorit.</label>
                        <label className="hidden lg:block">No Prioritarias</label>
                         <input type="number" name="CantNPrio" value={datas.CantNPrio} placeholder="0" onChange={handleChange} label="Area" disabled={Tag === 2 || datas.Prioritaria !== "SI"}/>
                       </div>
                    </div>   
                 </div> 
                 <div className="grid grid-cols-[minmax(0,1fr)_25%] gap-x-2 mt-2 items-end">
                   <div className="flex items-center pb-2 min-w-0 gap-2">
                    <Switch name="Acompanante" value={datas.Acompanante} onChange={handleChange} checkedValue="SI" uncheckedValue="NO"/>
                     <label className="whitespace-nowrap">
                        Registrar datos del acompañante
                     </label>
                   </div>
                   <div className="w-[6.2rem] justify-self-end">
                     <label className="block">
                       Orden
                     </label>
                     <input type="number" className="w-full" name="Orden" value={datas.Orden} placeholder="0" onChange={handleChange} autoComplete="off" disabled={Tag === 2} />
                   </div>
                 </div>
            </div>
            <div className="flex w-full gap-4 mt-6 justify-end">
                <button name="Aceptar" className="btnprimary" onClick={handleAceptar} disabled={habilita} type="button">Aceptar</button>
                <button name="Cancelar" className="" onClick={handleCancel} disabled={habilita} type="button">Cancelar</button>
            </div>
        </form>
        </div> 
        {showIconos && (
            <IconModal
              showI={showIconos}
              handleshowI={setShowIconos}
              setIcon={handleSetIcon}
            ></IconModal>
        )}
      </Modal>
    </>
  );
}

ServiceModal.propTypes = {
  show: PropTypes.bool.isRequired,
  AreaI: PropTypes.number.isRequired, 
  AreaFId: PropTypes.number.isRequired, 
  ServicioI: PropTypes.number.isRequired, 
  Tag: PropTypes.number.isRequired,
  handleshow: PropTypes.func.isRequired,
  onGuardado: PropTypes.func.isRequired,
};

export default ServiceModal;
